import { render, staticRenderFns } from "./Suggests.vue?vue&type=template&id=2bb83314"
import script from "./Suggests.vue?vue&type=script&lang=js"
export * from "./Suggests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports